import type { SanityHeaderFooterLayoutProps, SanityPageDocument } from '../../../../../js/layout/SanityHeaderFooterLayout';
import SanityHeaderFooterLayout from '../../../../../js/layout/SanityHeaderFooterLayout';
import Breadcrumbs from '../../../../../js/sanity/components/Breadcrumbs';
import type { GrapeItemProps } from '../../../../../js/sanity/grid/GrapeItem';
import { GrapeItemPage } from '../../../../../js/sanity/grid/GrapeItem';
import SanityPage from '../../../../../js/sanity/infrastructure/SanityPage';
import type { Schema } from '../../../../../js/utils/StructuredData';
import StructuredData from '../../../../../js/utils/StructuredData';

export type Props = GrapeItemProps & SanityPageDocument;

export default SanityPage<Props>(({ page, breadcrumbs }) => (
    <article className="sanity" lang={page.metadata?.language}>
        <Breadcrumbs breadcrumbs={breadcrumbs} />
        <GrapeItemPage {...page} />
        <section>
            <a className="btn-secondary" href={page.listPage?.path}>
                Se flere druer
            </a>
            <StructuredData data={page} mapper={mapper} />
        </section>
    </article>
));

// Force this file to be treated as a page
export function StaticLayout({ props, url }: SanityHeaderFooterLayoutProps<Props>) {
    return <SanityHeaderFooterLayout props={props} url={url} dynamic />;
}

export const onRequest = () => null;

export const path = __FILE_PATH__;

function mapper(data: Props): Schema {
    return {
        '@context': 'https://schema.org',
        '@type': 'DefinedTerm',
        name: data.name,
        description: data.summary,
        inDefinedTermSet: data.listPage.path,
        alternateName: data.synonyms,
    };
}

export function toMetadata({ name, summary }: Props) {
    return { title: name, description: summary };
}
